<mat-form-field appearance="outline">
	<mat-label>{{ label }}</mat-label>
	<input
		matInput
		[attr.data-cy]="property === 'available_at' ? 'activity-editor-availability-date-picker' : 'activity-editor-due-date-picker'"
		[matDatepicker]="datetimePicker"
		[formControl]="control"
		[min]="minDate"
		[max]="maxDate"
	/>
	<mat-datepicker-toggle matIconSuffix [for]="datetimePicker"></mat-datepicker-toggle>
	<mat-datepicker #datetimePicker (closed)="onDatePickerClosed()" panelClass="activity-datetime-picker-overlay">
		<mat-datepicker-actions>
			<div class="time-picker-container">
				<label class="time-label">{{ 'common_time' | translate }}:</label>
				<input
					type="time"
					class="native-time-input"
					[value]="timeString$ | async"
					(change)="onTimeChange($event)"
				/>
			</div>
			<div class="datepicker-actions">
				<button
					type="button"
					class="tertiary-btn"
					(click)="clearValue()"
					matDatepickerCancel
					translate="datetimepicker_clear">
				</button>
				<button
					type="button"
					class="primary-btn"
					matDatepickerApply
					translate="common_done">
				</button>
			</div>
		</mat-datepicker-actions>
	</mat-datepicker>
</mat-form-field>
